import { render, staticRenderFns } from "./videouploadinfo.vue?vue&type=template&id=936efcf0&"
import script from "./videouploadinfo.vue?vue&type=script&lang=js&"
export * from "./videouploadinfo.vue?vue&type=script&lang=js&"
import style0 from "./videouploadinfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports